<template>
  <v-card class="box-container" style="max-height: 80vh;">
    <v-row justify="center" class="row-header ma-0 pa-0 pa-1">
      <v-spacer></v-spacer>
      <span class="title">Операции</span>
      <v-spacer></v-spacer>
      <v-btn color="error" text fab small @click="close">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-row>
    <v-divider class="row-header"></v-divider>
    <div outlined class="row-content">
      <v-row justify="center" class="pa-0 ma-0 ma-1">
        <v-col cols="12" xl="6" lg="6" md="12" sm="12" xs="12" :class="isOnMobile ? 'ma-0 pa-1' : 'ma-0 pa-2'">
          <v-btn :color="isInDarkMode ? '' : 'blue lighten-4'" block tile class="elevation-0" @click="goToMoneyInOut" :large="!isOnMobile" :small="isOnMobile">
            <v-icon class="mr-2 ml-2" color="#1685c9">mdi-cash-register</v-icon>
            <span class="button-span">{{ isOnMobile ? "Въвеждане / извеждане" : "Въвеждане / извеждане на сума" }}</span>
          </v-btn>
        </v-col>
        <v-col cols="12" xl="6" lg="6" md="12" sm="12" xs="12" :class="isOnMobile ? 'ma-0 pa-1' : 'ma-0 pa-2'">
          <v-btn :color="isInDarkMode ? '' : 'blue lighten-4'" block tile class="elevation-0" @click="goToMonthlyRep" :large="!isOnMobile" :small="isOnMobile">
            <v-icon class="mr-2 ml-2" color="#1685c9">mdi-calendar-month</v-icon>
            <span class="button-span">Месечен отчет</span>
          </v-btn>
        </v-col>
      </v-row>
      <v-row justify="center" class="ma-1">
        <v-col cols="12" class="ma-0 pa-1">
          <v-divider></v-divider>
        </v-col>
      </v-row>
      <v-row justify="center" class="ma-1">
        <v-col cols="12" xl="6" lg="6" md="12" sm="12" xs="12" :class="isOnMobile ? 'ma-0 pa-1' : 'ma-0 pa-2'">
          <v-btn :color="isInDarkMode ? '' : 'blue lighten-4'" block tile class="elevation-0" @click="printReport(reports.dailyRepZ)" :large="!isOnMobile" :small="isOnMobile">
            <v-icon class="mr-2 ml-2" color="#1685c9">mdi-alpha-z-box</v-icon>
            <span class="button-span">{{ isOnMobile ? "Дневен Z отчет" : "Дневен Z отчет (с нулиране)" }}</span>
          </v-btn>
        </v-col>
        <v-col cols="12" xl="6" lg="6" md="12" sm="12" xs="12" :class="isOnMobile ? 'ma-0 pa-1' : 'ma-0 pa-2'">
          <v-btn :color="isInDarkMode ? '' : 'blue lighten-4'" block tile class="elevation-0" @click="printReport(reports.dailyRepX)" :large="!isOnMobile" :small="isOnMobile">
            <v-icon class="mr-2 ml-2" color="#1685c9">mdi-alpha-x-box-outline</v-icon>
            <span class="button-span">{{ isOnMobile ? "Дневен X отчет" : "Дневен X отчет (без нулиране)" }}</span>
          </v-btn>
        </v-col>
      </v-row>
      <v-row justify="center" class="ma-1">
        <v-col cols="12" class="ma-0 pa-1">
          <v-divider></v-divider>
        </v-col>
      </v-row>
      <v-row justify="center" class="ma-1">
        <v-col cols="12" xl="6" lg="6" md="12" sm="12" xs="12" :class="isOnMobile ? 'ma-0 pa-1' : 'ma-0 pa-2'">
          <v-btn :color="isInDarkMode ? '' : 'blue lighten-4'" block tile class="elevation-0" @click="printReport(reports.operatorsRepZ)" :large="(!isOnMobile)" :small="isOnMobile">
            <v-icon class="mr-2 ml-2" color="#1685c9">mdi-alpha-o-box</v-icon>
            <span class="button-span">{{ isOnMobile ? "Операторски Z отчет" : "Операторски Z отчет (с нулиране)" }}</span>
          </v-btn>
        </v-col>
        <v-col cols="12" xl="6" lg="6" md="12" sm="12" xs="12" :class="isOnMobile ? 'ma-0 pa-1' : 'ma-0 pa-2'">
          <v-btn :color="isInDarkMode ? '' : 'blue lighten-4'" block tile class="elevation-0" @click="printReport(reports.operatorsRepX)" :large="!isOnMobile" :small="isOnMobile">
            <v-icon class="mr-2 ml-2" color="#1685c9">mdi-alpha-o-box-outline</v-icon>
            <span class="button-span">{{ isOnMobile ? "Операторски X отчет" : "Операторски X отчет (без нулиране)" }}</span>
          </v-btn>
        </v-col>
      </v-row>
      <v-row justify="center" class="ma-1">
        <v-col cols="12" class="ma-0 pa-1">
          <v-divider></v-divider>
        </v-col>
      </v-row>
      <v-row justify="center" class="ma-1">
        <v-col cols="12" xl="6" lg="6" md="12" sm="12" xs="12" :class="isOnMobile ? 'ma-0 pa-1' : 'ma-0 pa-2'">
          <v-btn :color="isInDarkMode ? '' : 'blue lighten-4'" block tile class="elevation-0" @click="printReport(reports.articleRepZ)" :large="!isOnMobile" :small="isOnMobile">
            <v-icon class="mr-2 ml-2" color="#1685c9">mdi-alpha-a-box</v-icon>
            <span class="button-span">{{ isOnMobile ? "Артикулен Z отчет" : "Артикулен Z отчет (с нулиране)" }}</span>
          </v-btn>
        </v-col>
        <v-col cols="12" xl="6" lg="6" md="12" sm="12" xs="12" :class="isOnMobile ? 'ma-0 pa-1' : 'ma-0 pa-2'">
          <v-btn :color="isInDarkMode ? '' : 'blue lighten-4'" block tile class="elevation-0" @click="printReport(reports.articleRepX)" :large="!isOnMobile" :small="isOnMobile">
            <v-icon class="mr-2 ml-2" color="#1685c9">mdi-alpha-a-box-outline</v-icon>
            <span class="button-span">{{ isOnMobile ? "Артикулен X отчет" : "Артикулен X отчет (без нулиране)" }}</span>
          </v-btn>
        </v-col>
      </v-row>
      <v-row justify="center" class="ma-1">
        <v-col cols="12" class="ma-0 pa-1">
          <v-divider></v-divider>
        </v-col>
      </v-row>
      <v-row justify="center" class="ma-1">
        <v-col cols="12" xl="6" lg="6" md="12" sm="12" xs="12" :class="isOnMobile ? 'ma-0 pa-1' : 'ma-0 pa-2'">
          <v-tooltip bottom color="warning" :disabled="fp.maxSupportedClients != 0">
            <template v-slot:activator="{ on }">
              <div v-on="on">
                <v-btn :color="isInDarkMode ? '' : 'blue lighten-4'" block tile class="elevation-0" @click="printReport(reports.clientsRepZ)" :large="!isOnMobile" :small="isOnMobile" :disabled="fp.maxSupportedClients == 0">
                  <v-icon class="mr-2 ml-2" color="#1685c9">mdi-alpha-c-box</v-icon>
                  <span class="button-span">{{ isOnMobile ? "Клиентски Z отчет" : "Клиентски Z отчет (с нулиране)" }}</span>
                </v-btn>
              </div>
            </template>
            <span>Устройството не поддържа работа с клиенти!</span>
          </v-tooltip>
        </v-col>
        <v-col cols="12" xl="6" lg="6" md="12" sm="12" xs="12" :class="isOnMobile ? 'ma-0 pa-1' : 'ma-0 pa-2'">
          <v-tooltip bottom color="warning" :disabled="fp.maxSupportedClients != 0">
            <template v-slot:activator="{ on }">
              <div v-on="on">
                <v-btn :color="isInDarkMode ? '' : 'blue lighten-4'" block tile class="elevation-0" @click="printReport(reports.clientsRepX)" :large="!isOnMobile" :small="isOnMobile" :disabled="fp.maxSupportedClients == 0">
                  <v-icon class="mr-2 ml-2" color="#1685c9">mdi-alpha-c-box-outline</v-icon>
                  <span class="button-span">{{ isOnMobile ? "Клиентски X отчет" : "Клиентски X отчет (без нулиране)" }}</span>
                </v-btn>
              </div>
            </template>
            <span>Устройството не поддържа работа с клиенти!</span>
          </v-tooltip>
        </v-col>
      </v-row>
      <v-row justify="center" class="ma-1">
        <v-col cols="12" class="ma-0 pa-1">
          <v-divider></v-divider>
        </v-col>
      </v-row>
      <v-row justify="center" class="pa-0 ma-0 ma-1">
        <v-col cols="12" xl="6" lg="6" md="12" sm="12" xs="12" :class="isOnMobile ? 'ma-0 pa-1' : 'ma-0 pa-2'">
          <v-btn :color="isInDarkMode ? '' : 'blue lighten-4'" block tile class="elevation-0" @click="goInProgDepMode" :large="!isOnMobile" :small="isOnMobile">
            <v-icon class="mr-2 ml-2" color="#1685c9">mdi-cog-transfer</v-icon>
            <span class="button-span">Програмиране на департаменти</span>
          </v-btn>
        </v-col>
        <v-col cols="12" xl="6" lg="6" md="12" sm="12" xs="12" :class="isOnMobile ? 'ma-0 pa-1' : 'ma-0 pa-2'">
          <v-btn :color="isInDarkMode ? '' : 'blue lighten-4'" block tile class="elevation-0" @click="goInProgArtMode" :large="!isOnMobile" :small="isOnMobile">
            <v-icon class="mr-2 ml-2" color="#1685c9">mdi-group</v-icon>
            <span class="button-span">Програмиране на артикули</span>
          </v-btn>
        </v-col>
      </v-row>

      <v-row justify="center" class="pa-0 ma-0 ma-1">
        <v-col cols="12" xl="6" lg="6" md="12" sm="12" xs="12" :class="isOnMobile ? 'ma-0 pa-1' : 'ma-0 pa-2'">
          <v-tooltip bottom color="warning" :disabled="fp.maxSupportedClients != 0">
            <template v-slot:activator="{ on }">
              <div v-on="on">
                <v-btn :color="isInDarkMode ? '' : 'blue lighten-4'" block tile class="elevation-0" @click="goToProgClients" :large="!isOnMobile" :small="isOnMobile" :disabled="fp.maxSupportedClients == 0">
                  <v-icon class="mr-2 ml-2" color="#1685c9">mdi-account-arrow-left</v-icon>
                  <span class="button-span">Програмиране на клиенти</span>
                </v-btn>
              </div>
            </template>
            <span>Устройството не поддържа работа с клиенти!</span>
          </v-tooltip>
        </v-col>
      </v-row>
      <v-row justify="center" class="ma-1">
        <v-col cols="12" class="ma-0 pa-1">
          <v-divider></v-divider>
        </v-col>
      </v-row>
      <v-row justify="start" class="ma-1">
        <v-col cols="12" xl="6" lg="6" md="12" sm="12" xs="12" :class="isOnMobile ? 'ma-0 pa-1' : 'ma-0 pa-2'">
          <v-btn :color="isInDarkMode ? '' : 'blue lighten-4'" block tile class="elevation-0" @click="printDiagnostics" :large="!isOnMobile" :small="isOnMobile">
            <v-icon class="mr-2 ml-2" color="#1685c9">mdi-hammer-wrench</v-icon>
            <span class="button-span">Диагностика</span>
          </v-btn>
        </v-col>
        <v-col cols="12" xl="6" lg="6" md="12" sm="12" xs="12" :class="isOnMobile ? 'ma-0 pa-1' : 'ma-0 pa-2'">
          <v-btn :color="isInDarkMode ? '' : 'blue lighten-4'" block tile class="elevation-0" align-left @click="setDateAndTime" :large="!isOnMobile" :small="isOnMobile">
            <v-icon class="mr-2 ml-2" color="#1685c9">mdi-clock-outline</v-icon>
            <span class="button-span">Сверяване на дата и час</span>
          </v-btn>
        </v-col>
      </v-row>
    </div>
  </v-card>
</template>

<script>
import Const from "../constants";
import Tremol from "../assets/fp/fp";

export default {
  data() {
    return {
      reports: {
        dailyRepX: "Дневен отчет без нулиране",
        dailyRepZ: "Дневен отчет с нулиране",
        operatorsRepX: "Операторски отчет без нулиране",
        operatorsRepZ: "Операторски отчет с нулиране",
        articleRepX: "Артикулен отчет без нулиране",
        articleRepZ: "Артикулен отчет с нулиране",
        clientsRepX: "Клиентски отчет без нулиране",
        clientsRepZ: "Клиентски отчет с нулиране",
        monthlyRep: "Месечен отчет"
      }
    };
  },
  methods: {
    close() {
      this.fp.exitMode(Const.Modes.Operations);
    },
    goToMoneyInOut() {
      this.fp.addMode(Const.Modes.MoneyInOut);
    },
    goToMonthlyRep() {
      this.fp.addMode(Const.Modes.MonthlyRep);
    },
    goInProgDepMode() {
      this.fp.addMode(Const.Modes.ProgramDepartments);
    },
    goInProgArtMode() {
      this.fp.addMode(Const.Modes.ProgramArticles);
    },
    goToProgClients() {
      this.fp.addMode(Const.Modes.ProgClients);
    },
    setDateAndTime() {
      this.fp.addMode(Const.Modes.SetDateTime);
    },
    printReport(repType) {
      this.fp.executeWithLoader(async () => {
        try {
          switch (repType) {
            case this.reports.dailyRepX:
              await this.fp.PrintDailyReport(Tremol.Enums.OptionZeroing.Without_zeroing);
              break;
            case this.reports.dailyRepZ:
              await this.fp.PrintDailyReport(Tremol.Enums.OptionZeroing.Zeroing);
              break;
            case this.reports.operatorsRepX:
              await this.fp.PrintOperatorReport(Tremol.Enums.OptionZeroing.Without_zeroing, 0);
              break;
            case this.reports.operatorsRepZ:
              await this.fp.PrintOperatorReport(Tremol.Enums.OptionZeroing.Zeroing, 0);
              break;
            case this.reports.articleRepX:
              await this.fp.PrintArticleReport(Tremol.Enums.OptionZeroing.Without_zeroing);
              break;
            case this.reports.articleRepZ:
              await this.fp.PrintArticleReport(Tremol.Enums.OptionZeroing.Zeroing);
              break;
            case this.reports.clientsRepX:
              await this.fp.PrintCustomerReport(Tremol.Enums.OptionZeroing.Without_zeroing);
              break;
            case this.reports.clientsRepZ:
              await this.fp.PrintCustomerReport(Tremol.Enums.OptionZeroing.Zeroing);
              break;
          }
          //this.close();
        } catch (ex) {
          this.fp.handleException(ex);
        }
      }, repType);
    },
    async printDiagnostics() {
      try {
        await this.fp.executeWithLoader(async () => {
          await this.fp.PrintDiagnostics();
        }, "Отпечатване на диагностика");
      } catch (ex) {
        this.fp.handleException(ex);
      }
    }
  },
  mounted() {},
  destroyed() {
    this.fp.exitMode(Const.Modes.Operations);
  }
};
</script>
<style>
.v-overlay__scrim {
  opacity: 0.8;
}
</style>
